import {
    api_url,
    legendLabelsBoxHeightLine,
    configChartsColorPalettes,
    partMobilityIndicators,
    popupInformation,
    defaultBarPercentage,
    defaultCategoryPercentage,
    defaultDatalabelsAnchor,
    defaultDatalabelsAlign,
    defaultDatalabelsFontWeight,
    defaultTicksCustomValue,
} from "../../../utils";

const BudgetMenageMobilite = {
    checked: false,
    titleSideBar: "Mobility Indicators Content.indicators.BudgetMenageMobilite",
    titleIndicator:
        "Mobility Indicators Content.indicators.BudgetMenageMobilite",
    popupInformation: {
        status: "false",
        text: popupInformation[partMobilityIndicators]["budgetMenageMobilite"],
    },
    keyFigure: {
        typeUpdate: "year", // year or geographical_area
        label: "",
        url: "",
        separator: "",
        position: "",
    },
    charts: [
        {
            typeChart: "bar",
            typeLabels: "geographical_areas", // years or geographical_areas
            multiYearGeographicalArea: true,
            singleYearGeographicalAreaType: "year", // year or geographical_area : MUST BE CONSISTENT WITH THE TYPE_LABEL ARGUMENT OF THE DATASET URL
            titleChart: "",
            titleDisplay: "true",
            legendDisplay: "false",
            legendCustom: "false",
            legendLabelsBoxHeight: legendLabelsBoxHeightLine,
            maintainAspectRatio: true,
            indexAxis: "x", // x or y
            heightChart: "350",
            widthChart: "600",
            i18nKeyLabels:
                "Mobility Indicators Content.charts.BudgetMenageMobilite.axis.labelsX",
            scales: {
                x: {
                    type: "category",
                    display: true,
                    stacked: true,
                    titleDisplay: false,
                    titleText: "",
                    gridDisplay: false,
                    beginAtZero: false,
                    ticks: {
                        display: true,
                        value: defaultTicksCustomValue,
                    },
                },
                y: {
                    type: "linear",
                    display: true,
                    stacked: false,
                    titleDisplay: true,
                    titleText:
                        "Mobility Indicators Content.charts.BudgetMenageMobilite.axis.titleY",
                    gridDisplay: true,
                    beginAtZero: true,
                    max: null,
                    ticks: {
                        display: true,
                        value: defaultTicksCustomValue,
                    },
                },
                yRight: {
                    type: "",
                    display: true,
                    stacked: false,
                    titleDisplay: true,
                    titleText:
                        "Mobility Indicators Content.charts.BudgetMenageMobilite.axis.titleYRight",
                    gridDisplay: false,
                    beginAtZero: true,
                    max: 100,
                    ticks: {
                        display: true,
                        value: defaultTicksCustomValue,
                    },
                },
            },
            annotationsProperties: {
                annotation1: undefined,
                annotation2: undefined,
            },
            keyFigure: {
                typeUpdate: "year", // year or geographical_area
                label: "",
                url: "",
                separator: "",
                position: "",
            },
            datasets: [
                {
                    type: "bar",
                    label: "Mobility Indicators Content.charts.BudgetMenageMobilite.legend.Revenu moyen par ménage (DH)",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=mobility-indicators&type_label=cusco_geographical_areas&indicator=budget_menage_mobilite&trend=projection&chart=revenu_moyen_menage&chart_data=True&chart_multi_year_geographical_area=True&indicator_key_figure=False&schema_city=",
                    backgroundColor:
                        configChartsColorPalettes[
                            "0_opacity_part_actifs_habitants"
                        ].backgroundColor,
                    borderColor:
                        configChartsColorPalettes[
                            "0_opacity_part_actifs_habitants"
                        ].borderColor,
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 0,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: defaultCategoryPercentage,
                    datalabelsProperties: {
                        display: true,
                        anchor: defaultDatalabelsAnchor,
                        align: defaultDatalabelsAlign,
                        font: {
                            weight: defaultDatalabelsFontWeight,
                        },
                        value: {
                            prefix: "",
                            suffix: "",
                            separator: "thousand",
                        },
                    },
                },
                {
                    type: "bar",
                    label: "Mobility Indicators Content.charts.BudgetMenageMobilite.legend.Budget transport (%)",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=mobility-indicators&type_label=cusco_geographical_areas&indicator=budget_menage_mobilite&trend=projection&chart=budget_transports&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor:
                        configChartsColorPalettes["0"].backgroundColor,
                    borderColor: configChartsColorPalettes["0"].borderColor,
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "yRight",
                    order: 0,
                    tooltipUnit: "%",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: defaultCategoryPercentage,
                    datalabelsProperties: {
                        display: true,
                        anchor: defaultDatalabelsAnchor,
                        align: defaultDatalabelsAlign,
                        color: undefined,
                        font: {
                            weight: "bold",
                        },
                        value: {
                            prefix: "",
                            suffix: "%",
                            separator: "",
                        },
                    },
                },
            ],
        },
    ],
};

export default BudgetMenageMobilite;
